import AmplitudeEvent from './AmplitudeEvent'
import { getPageName } from './utils'

// =============================================================================
// Abstract base class for all revenue events
// =============================================================================

abstract class RevenueAmplitudeEvent extends AmplitudeEvent {
  category = 'revenue'
}

// =============================================================================
// Revenue events (for descriptions, see the Notion doc)
// =============================================================================

export class ClickBuyEvent extends RevenueAmplitudeEvent {
  name = 'click buy'

  constructor(videoId: string, isPrimaryMarket: boolean) {
    super()
    this.properties = {
      video: videoId,
      is_primary_market: isPrimaryMarket,
    }
  }
}

export class ClickListForSaleEvent extends RevenueAmplitudeEvent {
  name = 'click list for sale'
}

export class ClickSellEvent extends RevenueAmplitudeEvent {
  name = 'click sell'

  constructor(videoId: string, isPrimaryMarket: boolean) {
    super()
    this.properties = {
      video: videoId,
      is_primary_market: isPrimaryMarket,
    }
  }
}

export class ClickCancelListingEvent extends RevenueAmplitudeEvent {
  name = 'click cancel listing'

  constructor(path: string) {
    super()
    this.properties = {
      page: getPageName(path),
    }
  }
}

export class ClickViewListingsEvent extends RevenueAmplitudeEvent {
  name = 'click view listings'
}

export class ClickViewOffersEvent extends RevenueAmplitudeEvent {
  name = 'click view offers'
}

export class ClickMakeOfferEvent extends RevenueAmplitudeEvent {
  name = 'click make offer'
}

export class ClickBuyOnListing extends RevenueAmplitudeEvent {
  name = 'click buy on listing'

  constructor(path: string) {
    super()
    this.properties = {
      page: getPageName(path),
    }
  }
}

export class ClickAcceptOfferEvent extends RevenueAmplitudeEvent {
  name = 'click accept offer'
}

export class ClickCancelOfferEvent extends RevenueAmplitudeEvent {
  name = 'click cancel offer'
}

export class ClickBuyInVideoPlayerEvent extends RevenueAmplitudeEvent {
  name = 'click buy in video player'
}

export class ClickSellInVideoPlayerEvent extends RevenueAmplitudeEvent {
  name = 'click sell in video player'
}

export class ClickAddToCalendarInVideoPlayerEvent extends RevenueAmplitudeEvent {
  name = 'click add to calendar in video player'
}

export class ClickBuyWithCreditCardPrimary extends RevenueAmplitudeEvent {
  name = 'click buy with credit card primary'

  constructor(videoId: string) {
    super()
    this.properties = {
      video: videoId,
    }
  }
}

export class ClickBuyWithCreditCardSecondary extends RevenueAmplitudeEvent {
  name = 'click buy with credit card secondary'

  constructor(videoId: string) {
    super()
    this.properties = {
      video: videoId,
    }
  }
}

export class ClickBuyWithETHPrimary extends RevenueAmplitudeEvent {
  name = 'click buy with eth primary'

  constructor(videoId: string) {
    super()
    this.properties = {
      video: videoId,
    }
  }
}

export class ClickBuyWithETHSecondary extends RevenueAmplitudeEvent {
  name = 'click buy with eth secondary'

  constructor(videoId: string) {
    super()
    this.properties = {
      video: videoId,
    }
  }
}

export class ClickExportFromCrossmint extends RevenueAmplitudeEvent {
  name = 'click export from crossmint'

  constructor(videoId: string) {
    super()
    this.properties = {
      video: videoId,
    }
  }
}
